export default "__VITE_PUBLIC_ASSET__b59c9fa2__"